import React from "react";
import { Link } from "react-router-dom";

export default function ContentCard({ item, to, className = "" }) {
  return (
    <Link
      to={to}
      className={`flex w-full items-center gap-4 border p-3 !no-underline opacity-90 transition duration-200 hover:-translate-y-0.5 hover:border-current hover:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${className}`}
    >
      <img src={item.image} alt="" className="h-20 w-24 shrink-0 object-cover bg-gray-100/10 md:h-24 md:w-36" />
      <div className="min-w-0 flex-1">
        <p className="text-xs tracking-wide opacity-60 !text-[color:var(--text-colour)]">{item.date}</p>
        <h3 className="mt-1 text-lg tracking-[0.12em] md:text-xl md:tracking-[0.18em]">{item.title}</h3>
        <p className="text-sm mt-1 opacity-80 line-clamp-2 !text-[color:var(--text-colour)]">{item.description}</p>
      </div>
    </Link>
  );
}
